import { render, staticRenderFns } from "./OutputIRPDashboard.vue?vue&type=template&id=6a00f8be&"
import script from "./OutputIRPDashboard.vue?vue&type=script&lang=js&"
export * from "./OutputIRPDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VContainer,VExpansionPanel,VExpansionPanels,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a00f8be')) {
      api.createRecord('6a00f8be', component.options)
    } else {
      api.reload('6a00f8be', component.options)
    }
    module.hot.accept("./OutputIRPDashboard.vue?vue&type=template&id=6a00f8be&", function () {
      api.rerender('6a00f8be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OutputIRPDashboard.vue"
export default component.exports